import fp from 'lodash/fp';
import { createSelector } from 'reselect';
import toArrayWithQuantity from '../../../../helpers/toArrayWithQuantity';
import { getInventoryPackage as stateContext } from '.';

export const getPagination = createSelector(stateContext, fp.get('pagination'));

export const getPaginationPages = createSelector(
  getPagination,
  fp.get('pages')
);

export const getPaginationWithoutPages = createSelector(
  getPagination,
  fp.omit('pages')
);

export const getPaginationQueryOptions = createSelector(
  getPagination,
  ({ currentPage: page, limit }) => ({
    page,
    limit
  })
);

export const getPaginationLoadedPages = createSelector(
  getPaginationPages,
  fp.mapValues(() => true)
);

export const getCurrentPagePackages = createSelector(stateContext, state => {
  const page = fp.getOr(1, 'pagination.currentPage', state);
  const pageItemIds = fp.get(`pagination.pages.${page}.ids`, state);
  const pageItemsByIds = fp.pick(pageItemIds, state.all);
  return toArrayWithQuantity(pageItemsByIds);
});
